import React          from 'react'
import ReactDOM       from 'react-dom'
import BaseController from 'controllers/base'
import App            from 'containers/OnboardingFunnel/App'

class Controller extends BaseController {
  call() {
    super.call();
    if (document.getElementById("react-root")) {
      ReactDOM.render(<App />, document.getElementById("react-root"))
    }
  }
};

export default Controller;
